<!--婴幼儿管理-->
<template>
  <div class="app-container">
    <el-card class="operate-container" shadow="never" style="margin-top: 0px">
      <div class="filter-container">
        <el-form :inline="true" :model="queryParam" label-width="90px">
          <el-form-item label="商户名称:">
            <el-input v-model="queryParam.title" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="法人姓名:">
            <el-input v-model="queryParam.legalName" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="法人手机号:">
            <el-input v-model="queryParam.legalPhone" placeholder="请输入小名"></el-input>
          </el-form-item>
          <!-- <el-form-item label="联系人手机号:">
            <el-input v-model="queryParam.inputChildNickName" placeholder="请输入小名" ></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="入驻时间:">
            <el-date-picker v-model="queryParam.inputChildNickName" type="daterange" value-format="yyyy-MM-dd"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item > -->
          <el-form-item style="margin-left: 30px">
            <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查
              询</el-button>
            <el-button type="warning" size="medium" class="operator-btn2" icon="el-icon-refresh"
              @click="handleResetSearch()" style="margin-left: 30px">重 置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <div class="app-container-content">
      <div class="table-container" style="margin-top: 20px">
        <el-table ref="tableData" style="width: 100%" :data="tableData" max-height="520" border
          :highlight-current-row="false" :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }" @row-click="rowClick" @selection-change="handleSelectionChange">
          <el-table-column type="index" label="序号" width="55"> </el-table-column>
          <el-table-column label="门店全称" prop="title" width="120">
          </el-table-column>
          <el-table-column label="法人姓名" prop="legalName" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="法人手机号" prop="legalPhone"> </el-table-column>
          <el-table-column label="联系人手机号" prop="principalPhone" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="入驻时间" prop="inputTime" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="操作" width="180" align="center">
            <template slot-scope="scope">
              <el-button v-if="scope.row.status == '0'" size="mini" type="text" @click="handleUpdate(1, scope.row)">
                编辑
              </el-button>
              <el-button v-if="scope.row.status == '0'" size="mini" type="text" @click="handleUpdate(2, scope.row)">
                审核
              </el-button>
              <el-button size="mini" type="text" @click="handleUpdate(3, scope.row)">
                查看
              </el-button>
              <el-button v-if="scope.row.status == '0'" size="mini" type="text" @click="handleDelete(scope.row)">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="pagination-container">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper" :current-page.sync="queryParam.pageNum"
        :page-size="queryParam.pageSize" :page-sizes="queryParam.pageSizes" :total="queryParam.totalPage">
      </el-pagination>
    </div>


    <el-dialog :title="title" :visible.sync="qqMapDlg" width="70%" center>
      <distributions ref="refDistributions" v-if="ind == 1" :ruleForm="ruleForms" @submitFormtd="submitFormtds"
        :ind="ind">
      </distributions>
      <distribution v-else :ruleForm="ruleForms" @submitFormtd="submitFormtd" :ind="ind"></distribution>

    </el-dialog>

  </div>
</template>

<style scoped lang="scss">
/deep/ .el-table th.el-table__cell>.cell {
  // width: 90%;
  height: 100%;
  background: #ecf3fd;
  // border-radius: 8px;
}

/deep/ .el-table__header-wrapper .cell {
  line-height: 45px;
  color: #0d6fb8;
}

/deep/ .el-dialog--center {
  border: 2px solid #d0d0d0;
  border-radius: 10px;
}

/deep/ .el-dialog__header {
  border-radius: 10px;
  background: #f0f7ff;
}

.app-container {
  .operate-container {
    border: none;
  }

  .el-form-item {
    margin-bottom: 0px;
  }

  /deep/ .el-card__body {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  &-content {
    background: #ffffff;
    border-radius: 8px;
    margin-top: 20px;
  }

  /deep/ .el-dialog__body {
    padding-top: 10px;
    padding-bottom: 10px;
  }


  /deep/ .el-dialog {
    margin-top: 5vh !important;
  }

  .table-container {
    border: none;
    border-radius: 0px;

    /deep/ .el-table {
      .el-table__header-wrapper {
        .el-table__cell {
          padding: 0px;
        }
      }
    }
  }
}

/deep/ .el-date-editor .el-range-separator {
  width: 10%;
}
</style>

<script>
import { storeFrontAuditPage, examineFrontAudit, updStoreFrontAudit, delStoreFrontAudit } from '../../../api/ActivitySetting';
import distribution from './distribution.vue';
import distributions from './distributions.vue';
export default {
  data() {
    return {
      ruleForms: {},
      qqMapDlg: false,
      queryParam: {
        title: '',
        legalName: '',
        legalPhone: '',
        //分页查询
        pageNum: 1, //当前第几页
        totalPage: 1, //总共页数
        pageSize: 10,
        pageSizes: [10, 20, 30],
      },
      selectRow: null,
      tableData: [],
      ind: 1,
      title: '审核'
    };
  },
  components: {
    distribution,
    distributions
  },
  created() {
    // 列表数据
    this.storeFront()
  },
  activated() { },
  mounted() { },
  methods: {
    // 修改
    submitFormtds(v) {
      updStoreFrontAudit({
        ...v
      }).then((res) => {
        console.log(res, 'vvvvvvvvvv=')
        if (res.code == 20000) {
          this.$message.success('修改成功');
          this.qqMapDlg = false
          // 列表数据
          this.storeFront()
        }
      })
    },
    submitFormtd(v) {
      examineFrontAudit({
        status: v,
        id: this.ruleForms.id
      }).then((res) => {
        if (res.code == 20000) {
          this.$message.success('审核完成');
          this.qqMapDlg = false
          // 列表数据
          this.storeFront()
        }
      })
    },
    // 删除
    handleDelete(row) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delStoreFrontAudit({
          id: row.id
        }).then((res) => {
          if (res.code == 20000) {
            this.$message.success('删除成功');
            // 列表数据
            this.storeFront()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    handleUpdate(ind, row) {
      this.ind = ind
      let ovj = row.businessTime.split(',')
      this.ruleForms = row
      this.$set(this.ruleForms, 'businessTimeList', ovj)
      if (ind == 1) {
        this.title = '编辑'
      } else if (ind == 2) {
        this.title = '审核'
      } else if (ind == 3) {
        this.title = '查看'
      }
      this.qqMapDlg = true
      this, this.$nextTick(() => {
        this.$refs['refDistributions'].$refs['refUpload'].imageUrl = row.picUrls
        this.$refs['refDistributions'].$refs['uploadRef'].imageUrl = row.businessLicense
      })

    },
    onBtnSearch() {
      // 列表数据
      this.storeFront()
    },
    handleResetSearch() {
      this.queryParam = {
        title: '',
        legalName: '',
        legalPhone: '',
        //分页查询
        pageNum: 1, //当前第几页
        totalPage: 1, //总共页数
        pageSize: 10,
        pageSizes: [10, 20, 30],
      }
      this.storeFront()
    },
    // 列表数据
    storeFront() {
      storeFrontAuditPage({ ...this.queryParam }).then((res) => {
        if (res.code == 20000) {
          this.tableData = res.data.list
        }
      })
    },
    rowClick(row, column, event) {
      console.log(row, "=====rowClik");
      this.selectRow = row;
    },
    handleSelectionChange(val) {
    },
    handleSizeChange(val) {
      this.queryParam.pageNum = 1;
      this.queryParam.pageSize = val;
      this.storeFront();
    },
    handleCurrentChange(val) {
      this.queryParam.pageNum = val;
      this.queryParam.pageSize = 10;
      this.storeFront();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/superadmin/StoreFrontAudit/index.vue